export default class AssistantButton {
  constructor() {
    this.assistantButtons = Array.from(
      document.querySelectorAll('.assistant-button'),
    );
    this.isOpen = false;
  }

  setListeners() {
    if (this.assistantButtons.length > 0) {
      this.assistantButtons.forEach(button => {
        button.addEventListener('click', () => {
          if (!this.isOpen) {
            window.GuideSDK.bot.openWindow();
            this.isOpen = true;
          } else {
            window.GuideSDK.bot.closeWindow();
            this.isOpen = false;
          }
        });
      });
    }
  }

  static hideLauncher() {
    const interval = setInterval(() => {
      if (window.GuideSDK) {
        clearInterval(interval);

        // In order to hide the chatbot button to not overlap the map but still allow it open from the header
        // we have to style it this way.
        window.GuideSDK.bot.style.add(`
          div[class*="LauncherPortal"] {
            display: none;
          }
        `);
      }
    }, 200);

    setTimeout(() => clearInterval(interval), 3000);
  }
}

(() => {
  const assistantButton = new AssistantButton();
  assistantButton.setListeners();
})(Drupal);
